import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import UserShell from "@/components/UserShell";
import AdminShell from "@/components/AdminShell";
import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage, AdminLoginPage } from "@/pages/AuthPages";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Deposit from "@/pages/Deposit";
import Exchange from "@/pages/Exchange";
import Trade from "@/pages/Trade";
import Referrals from "@/pages/Referrals";
import Transactions from "@/pages/Transactions";
import Notifications from "@/pages/Notifications";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminPaymentMethods from "@/pages/admin/AdminPaymentMethods";
import AdminDeposits from "@/pages/admin/AdminDeposits";
import AdminBonuses from "@/pages/admin/AdminBonuses";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAuditLogs from "@/pages/admin/AdminAuditLogs";
import AdminSellOrders from "@/pages/admin/AdminSellOrders";
import BrandIntro from "@/components/BrandIntro";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <BrandIntro />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/trade" element={<Trade />} />
          <Route element={<UserShell />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/deposit" element={<Deposit />} />
            <Route path="/exchange" element={<Exchange />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route path="/notifications" element={<Notifications />} />
          </Route>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminShell />}>
            <Route index element={<AdminOverview />} />
            <Route path="deposits" element={<AdminDeposits />} />
            <Route path="sell-orders" element={<AdminSellOrders />} />
            <Route path="payment-methods" element={<AdminPaymentMethods />} />
            <Route path="bonuses" element={<AdminBonuses />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="audit-logs" element={<AdminAuditLogs />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
